<template>
  <!-- 公司访问设置 -->
  <div class="app-container">
    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" border v-loading="loading" stripe class="tableComent" bordersize="mini" height="100%">
        <el-table-column type="index" label="序号" width="55" align="center" fixed></el-table-column>
        <el-table-column label="操作" width="110" align="center" fixed>
          <template slot-scope="scope">
            <div>
              <el-button type="text" v-if="btnFlg[1]" size="mini" @click="updateFn(scope.row)">修改</el-button>
              <el-button type="text" v-if="btnFlg[2]" size="mini" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="人员名称" min-width="180" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNames" label="公司名称" min-width="400" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 20, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改人员企业配置 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addOrEditDialog" @close="addOrEditClose" center width="500px">
      <el-form :rules="rules" :model="addOrEditFrom" :validate-on-rule-change="false" ref="addOrEditFrom" class="demo-form-inline" label-width="100px" :inline="false" size="small" v-if="addOrEditDialog">
        <div class="addinpBox">
          <el-form-item label="人员名称:" prop="userName">
            <el-input v-model="addOrEditFrom.userName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="公司名称:" prop="companyCodes">
            <el-select v-model="addOrEditFrom.companyCodes" multiple filterable placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in gongsiList" :key="item.itemNo" :label="item.showName" :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="addOrEditSave" :loading="addLoading">确 定</el-button>
        <el-button @click="addOrEditClose" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { companySettingList, updateUserCompanySetting, deleteUserCompanySetting, getDictionaryDetailList } from '@/api/common-signature'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      emptyFn: emptyFn,
      h: '',
      btnFlg: [],
      btnIdArr: ['00FM1F0100', '00FM1F0200', '00FM1F0300'],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      tableList: [],
      gongsiList: [],
      title: '',
      addOrEditDialog: false,
      addOrEditFrom: {},
      addLoading: false,
      rules: {
        companyCodes: [
          { required: true, message: '请选择公司名称', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/companyAccessSetting')
    getDictionaryDetailList({ dictionaryType: 'company_name' }).then(res => { this.gongsiList = res || [] })
    if (this.btnFlg[0]) this.getList(this.searchFrom)
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 160) + 'px'
  },
  methods: {
    doLayout () {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    // 主数据
    getList (searchFrom) {
      this.loading = true
      companySettingList(searchFrom)
        .then((res) => {
          this.loading = false
          this.total = res.total || 0
          this.tableList = res.list || []
          this.doLayout()
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 修改
    updateFn (row) {
      this.title = '修改'
      this.addOrEditDialog = true
      this.addLoading = false
      const codes = row.companyCodes
        ? (Array.isArray(row.companyCodes) ? row.companyCodes : row.companyCodes.split(','))
        : []
      this.addOrEditFrom = {
        id: row.id,
        userCode: row.userCode,
        userName: row.userName,
        companyCodes: codes
      }
    },
    addOrEditClose () {
      this.addOrEditDialog = false
      this.$refs.addOrEditFrom.clearValidate()
    },
    addOrEditSave () {
      this.$refs.addOrEditFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          const codes = this.addOrEditFrom.companyCodes || []
          const names = codes.map(code => {
            const item = this.gongsiList.find(c => c.itemNo === code)
            return item ? item.showName : ''
          }).filter(Boolean).join(',')
          const payload = {
            id: this.addOrEditFrom.id,
            userCode: this.addOrEditFrom.userCode,
            userName: this.addOrEditFrom.userName,
            companyCodes: codes.join(','),
            companyNames: names
          }
          updateUserCompanySetting(payload).then(res => {
            loading.close()
            this.addLoading = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.addOrEditDialog = false
            this.addOrEditFrom = {}
            this.getList(this.searchFrom)
          }).catch(error => {
            this.addLoading = false
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.addLoading = false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteUserCompanySetting({ id: row.id }).then(() => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.addinpBox .el-input,
.addinpBox .el-select {
  width: 100%;
}
</style>
